export const LOGIN_SOURCE_PAGE = 'login'
export const REGISTRATION_SOURCE_PAGE = 'registration'

export enum CART_ACTION {
  ADD = 'add',
  CHECK_OVERDRAFTS = 'checkOverdrafts',
}

export const TARGET_PAGE_REDIRECT_PARAM = 'redirect'
export const TARGET_PAGE_CODE_PARAM = 'targetPageCode'
export const CHECKOUT_ADDRESS_TARGET_PAGE_CODE = 'checkoutAddress'
//For Birthday selector
export const DAYS_IN_MONTH = 31
export const MONTHS_IN_YEAR = 12
export const MAXIMUM_AGE = 120
export const MIN_AGE = 18
export const VALUE_ONE = 1
export const VALUE_TWO = 2

//BackendErrors
export const ERR_DOB_INVALID = 'customers.dateOfBirth.error'
export const ERR_DOB_TOO_YOUNG = 'customers.dateOfBirth.tooYoung'
export const ERR_EMAIL_INUSE = 'customers.email.alreadyExists'
export const ERR_EMAIL_INVALID = 'customers.email.invalid'
export const ERR_EMAIL_MISSING_INVALID_FORMAT =
  'customers.email.missingOrInvalidFormat'
export const ERR_FIRSTNAME_INVALID = 'customers.firstName.invalid'
export const ERR_LASTNAME_INVALID = 'customers.lastName.invalid'
export const ERR_SALUTATION_ERROR = 'customers.salutation.error'
export const ERR_PASSWORD_TOOSHORT = 'customers.password.tooShort'
export const ERR_TOS_NOT_ACCEPTED = 'customers.tosAccepted.notAccepted'
export const ERR_PASSWORD_LENGTH_EXCEEDED =
  'customer-authentication.error.customer.password-length-exceeded'

const EMAIL_FIELD = 'email'
const FIRSTNAME_FIELD = 'firstName'
const LASTNAME_FIELD = 'lastName'
const PASSWORD_FIELD = 'password'
const TOS_ACCEPTED_FIELD = 'tosAccepted'
const SALUTATION_FIELD = 'salutation'
const BIRTHDAY_YEAR_FIELD = 'birthDaySelectedYear'

export const ERR_MESSAGES_FIELD_MAP_REGISTRATION = new Map<
  string,
  | typeof EMAIL_FIELD
  | typeof FIRSTNAME_FIELD
  | typeof LASTNAME_FIELD
  | typeof PASSWORD_FIELD
  | typeof TOS_ACCEPTED_FIELD
  | typeof SALUTATION_FIELD
  | typeof BIRTHDAY_YEAR_FIELD
>([
  [ERR_DOB_INVALID, BIRTHDAY_YEAR_FIELD],
  [ERR_DOB_TOO_YOUNG, BIRTHDAY_YEAR_FIELD],
  [ERR_EMAIL_INUSE, EMAIL_FIELD],
  [ERR_EMAIL_INVALID, EMAIL_FIELD],
  [ERR_EMAIL_MISSING_INVALID_FORMAT, EMAIL_FIELD],
  [ERR_FIRSTNAME_INVALID, FIRSTNAME_FIELD],
  [ERR_LASTNAME_INVALID, LASTNAME_FIELD],
  [ERR_PASSWORD_LENGTH_EXCEEDED, PASSWORD_FIELD],
  [ERR_PASSWORD_TOOSHORT, PASSWORD_FIELD],
  [ERR_SALUTATION_ERROR, SALUTATION_FIELD],
  [ERR_TOS_NOT_ACCEPTED, TOS_ACCEPTED_FIELD],
])
